import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// Euro amounts and percentages formatted for the current language (Belgian conventions)
export default function useSimulatorFormat() {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const locale = i18n.language === "en" ? "en-GB" : `${i18n.language}-BE`;
    const currency = new Intl.NumberFormat(locale, { style: "currency", currency: "EUR" });
    const wholeCurrency = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    });
    const number = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });
    const percentFormats = {};
    return {
      money: (value) => currency.format(value),
      // Estimates are shown in whole euros
      wholeMoney: (value) => wholeCurrency.format(value),
      number: (value) => number.format(value),
      percent: (value, digits = 2) => {
        percentFormats[digits] ??= new Intl.NumberFormat(locale, {
          style: "percent",
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        });
        return percentFormats[digits].format(value);
      },
    };
  }, [i18n.language]);
}
